<img enTooltip
  [attr.data-placement]="placement"
  data-toggle="tooltip"
  data-animation="false"
  [attr.title]="title"

  src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon"/>
